import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import ChartPart from '../MainPanel/components/ChartPart/ChartPart';
import { SUCCESS } from '../../utils/constants';
import './OverviewScreen.scss';
import ArrowButton from '../../components/_atomic/ArrowButton/ArrowButton';

class OverviewScreen extends Component {
  static propTypes = {
    chartReport: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    chartCompareReport: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    getAllUsersShort: PropTypes.func.isRequired,
    hasMoreUsersShort: PropTypes.bool.isRequired,
    pageUsersShort: PropTypes.number.isRequired,
    usersShortStatus: PropTypes.string.isRequired,
    getChartReport: PropTypes.func.isRequired,
    usersShort: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    apps: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    getAppsStatus: PropTypes.string.isRequired,
    hasMoreApps: PropTypes.bool.isRequired,
    pageApps: PropTypes.number.isRequired,
    getApps: PropTypes.func.isRequired,
    currentAppCampaigns: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    getAppCampaigns: PropTypes.func.isRequired,
    getChartCompareReport: PropTypes.func.isRequired,
    resetChartCompareReport: PropTypes.func.isRequired,
    resetChartReport: PropTypes.func.isRequired,
    getExport: PropTypes.func.isRequired,
    sidebarStatus: PropTypes.bool,
    getTableReport: PropTypes.func.isRequired,
    getCurrentDate: PropTypes.func.isRequired,
  };
  static defaultProps = {
    sidebarStatus: true,
  }
  state = {};
  componentWillMount() {
    this.props.getAllUsersShort();
  }

  componentDidUpdate(prevProps) {
    const {
      usersShortStatus,
      hasMoreUsersShort,
      pageUsersShort,
      getAllUsersShort,
    } = this.props;

    if (
      usersShortStatus !== prevProps.usersShortStatus &&
      usersShortStatus === SUCCESS &&
      hasMoreUsersShort
    ) {
      getAllUsersShort({ page: pageUsersShort + 1 });
    }
  }
  navigateToBack = () => {
    window.history.back();
  }
  render() {
    const {
      chartReport,
      chartCompareReport,
      usersShort,
      getChartReport,
      apps,
      getAppsStatus,
      getApps,
      hasMoreApps,
      pageApps,
      getChartCompareReport,
      currentAppCampaigns, getAppCampaigns,
      resetChartCompareReport,
      resetChartReport,
      getExport,
      sidebarStatus,
      getTableReport,
      getCurrentDate,
    } = this.props;
    const overviewScreenClassNames = classNames({
      screen: true,
      'overview-screen': true,
    });

    return (
      <div className={overviewScreenClassNames}>
        <div className="main-label-no-transform">
          <ArrowButton onClick={this.navigateToBack} padLeft={sidebarStatus ? 125 : 125} />
          <span> Overview </span>
        </div>
        <ChartPart
          isAdmin
          isOverview
          getAppCampaigns={getAppCampaigns}
          chartReport={chartReport}
          chartCompareReport={chartCompareReport}
          users={usersShort}
          getChartReport={getChartReport}
          apps={apps}
          getAppsStatus={getAppsStatus}
          getApps={getApps}
          hasMoreApps={hasMoreApps}
          pageApps={pageApps}
          appCampaigns={currentAppCampaigns}
          getChartCompareReport={getChartCompareReport}
          resetCompare={resetChartCompareReport}
          resetChartReport={resetChartReport}
          getExport={getExport}
          getTableReport={getTableReport}
          getCurrentDate={getCurrentDate}
        />
      </div>
    );
  }
}

export default OverviewScreen;



// WEBPACK FOOTER //
// ./src/containers/OverviewScreen/OverviewScreen.js